import React, { useMemo, useCallback } from 'react';
import { useApp } from '@dex/bubl-dash/src/lib/functions/useApp';
import { useForm } from '@dex/bubl-dash/src/lib/functions/useForm';
import { Row, Col, Space } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import DeletePanel from '@dex/bubl-dash/src/lib/components/SinglePanels/DeletePanel';
import VenueLiveStreamApi from '../VenueLiveStreamApi';
import VenueLiveStreamCreateEditForm from './VenueLiveStreamCreateEditForm';
import VenueLiveStreamEditSessionVideo from './VenueLiveStreamEditSessionVideo';

const VenueLiveStreamSingleEdit: React.FC<any> = (props: any) => {

    const app = useApp();

    const { data } = props;

    const form = useForm(data);

    const update = VenueLiveStreamApi.update(data.id, "update", {
        onComplete: (data) => {

            app.alert('Booking Saved', 'success');

        }
    });

    const handleSubmit = useCallback((values) => {

        update.run({ data: values });

    }, [props]);

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <VenueLiveStreamCreateEditForm
                    mode={"edit"}
                    form={form}
                    data={data}
                    handleSubmit={handleSubmit}
                    process={update}
                />

                <Space />

                {data.hasVideo &&
                    <VenueLiveStreamEditSessionVideo
                        data={data}
                    />
                }

            </Col>

            <Col
                className={'side'}
            >

                <DeletePanel
                    data={data}
                />

            </Col>

        </Row>

    ), [data, form, update]);

}

export default VenueLiveStreamSingleEdit;
